export const getReservants = (baseUrl, identifiantEntite) => `${baseUrl}/api/reservants?perPage=200&idEntite=${identifiantEntite}`;
export const getTypesReservant = (baseUrl) => `${baseUrl}/api/typeReservant`;
